// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"Content_contentWrapper__19fdN","content":"Content_content__3H11O"};